import classes from "./Page.module.scss";

const Page = (props) => {
  return <main className={classes.main}>{props.children}</main>;
};

export default Page;
